const appState = {
  state: () => ({}),
  mutations: {},
  actions: {}
};
export default appState;
